import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../../utils/api';

const extendedApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    sendCodeForEnroll: build.mutation({
      query: (data) => ({
        url: `${apiUrl.sendCodeForEnroll}?DonorId=${data.donorId}&PhoneNumber=${data.phoneNumer}`,
        method: 'POST',
      })
    }),
  }),
  overrideExisting: false,
});
export const {
  useSendCodeForEnrollMutation
} = extendedApi;
